import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMyProfileDetails } from "api/authService";
import { useAuth } from "context/UserContext";
import { Sentry } from "react-activity";
import Loader from "components/Loader";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const { setUpdateUser } = useAuth();

  useEffect(() => {
    const fetchProfile = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      if (token) {
        localStorage.setItem("authToken", token);

        try {
          const res = await getMyProfileDetails();
          if (res?.success) {
            const user = res.body;
            console.log('auth', user)
            localStorage.setItem("authUser", JSON.stringify(user));
            setUpdateUser(user); // Update user context
          }
        } catch (err) {
          console.error("Failed to fetch profile:", err);
        }
      }

      // Always redirect after processing
      navigate("/");
    };

    fetchProfile();
  }, [navigate, setUpdateUser]);

  return (
    <div className="loaderdiv">
      {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
      <Loader  style={{width: 100, height: 100}} />
    </div>
  );
};

export default AuthRedirect;
